
export const ratingValues = [1, 2, 3, 4, 5];

export const activeStatuses = [
  { label: 'Only Active', value: 'true' },
  { label: 'Only Inactive', value: 'false' },
  { label: 'Both', value: null }
];

export const favStatuses = {
  blocked: 'block',
  favorite: 'fav'
};



// WEBPACK FOOTER //
// ./src/constants/workers.js